import { Chip } from '@heroui/react';

import type { ContactMessageStatus } from '@/types';

const STATUS_LABELS: Record<ContactMessageStatus, { label: string; color: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' }> = {
  new: { label: 'New', color: 'danger' },
  in_progress: { label: 'In Progress', color: 'warning' },
  resolved: { label: 'Resolved', color: 'success' },
  archived: { label: 'Archived', color: 'default' }
};

interface ContactMessageStatusBadgeProps {
  status: ContactMessageStatus;
  readAt?: string | null;
  className?: string;
}

export function ContactMessageStatusBadge({ status, readAt, className }: ContactMessageStatusBadgeProps) {
  const config = STATUS_LABELS[status];
  const isUnread = status === 'new' && !readAt;

  return (
    <Chip
      className={`gap-1 px-3 py-1 text-xs font-semibold ${className ?? ''}`}
      color={config?.color ?? 'default'}
      size="sm"
      variant={isUnread ? 'solid' : 'flat'}
    >
      {isUnread && <span className="bg-success mr-1 inline-block h-2 w-2 rounded-full" />}
      {config?.label ?? status}
    </Chip>
  );
}

